var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var _a, _b;
import { ResetCompanyNotificationLimitsRequestModel, CompanyNotificationSummaryModel, NotificationPreferencesClient, ResetCompanyNotificationLimitsCommand } from "@/app/api/battery-portal-api";
import { LoginState } from "@/app/store/modules/login.state";
import { DateHelper } from "@/app/utils/date-helper";
import { HttpHelper } from "@/app/utils/http-helper";
import { Notifier } from "@/common/utils/notifier";
import { Component, Prop, Vue, Watch } from "vue-facing-decorator";
import { State } from "vuex-facing-decorator";
const notificationPreferencesClient = new NotificationPreferencesClient(window.apiUrl);
let CompanyNotificationSummaryVue = class CompanyNotificationSummaryVue extends Vue {
    constructor() {
        super(...arguments);
        this.working = false;
        this.placeholderText = "N/A";
        this.data = new CompanyNotificationSummaryModel();
        this.lowerLimit = 1;
        this.upperLimit = 100;
        // What the server sent, before anyone touched the inputs.
        //
        // A company that has not set its own limits stores null and inherits the system-wide default,
        // and the summary resolves that default for display. Without remembering what arrived, saving
        // an untouched form writes the resolved default back as though the user had chosen it -
        // which both pins the company to today's default and puts a change nobody made in the Audit
        // Log.
        this.loadedEmailLimit = null;
        this.loadedSmsLimit = null;
    }
    created() {
    }
    ;
    mounted() {
        this.getSummary();
    }
    ;
    getSummary() {
        return __awaiter(this, void 0, void 0, function* () {
            if (!this.companyId)
                return;
            return yield notificationPreferencesClient
                .getCompanyNotificationSummary(this.companyId, DateHelper.getCurrentDateAsString())
                .then(response => {
                this.data = response;
                this.loadedEmailLimit = this.maxDailyAlarmEmailLimitPerSystem;
                this.loadedSmsLimit = this.maxDailyAlarmSmsLimitPerSystem;
            })
                .catch(ex => {
                HttpHelper.handleResponse(ex, () => {
                    Notifier.onServerError(ex);
                });
            })
                .finally(() => {
                this.working = false;
            });
        });
    }
    ;
    reset() {
        return __awaiter(this, void 0, void 0, function* () {
            if (!this.isClientAdministrator)
                return;
            if (!this.validate())
                return;
            if (this.working)
                return;
            this.working = true;
            let command = new ResetCompanyNotificationLimitsCommand();
            let model = new ResetCompanyNotificationLimitsRequestModel();
            model.timezoneOffset = DateHelper.getTimezoneOffset();
            model.companyPreferences = this.data.notificationPreferences;
            command.requestModel = model;
            return yield notificationPreferencesClient
                .resetCompanyNotificationLimits(command)
                .then(_ => {
                Notifier.onOk();
            })
                .catch(ex => {
                HttpHelper.handleResponse(ex, () => {
                    Notifier.onServerError(ex);
                });
            })
                .finally(() => __awaiter(this, void 0, void 0, function* () {
                this.working = false;
                yield this.getSummary();
            }));
        });
    }
    ;
    validate() {
        var _a, _b, _c, _d;
        let model = this.data.notificationPreferences;
        if (!model)
            return false;
        if (((_a = model.maxDailyAlarmEmailLimitPerSystem) !== null && _a !== void 0 ? _a : 0) < this.lowerLimit) {
            Notifier.onWarning(`Limit cannot be lower than ${this.lowerLimit}`);
            return false;
        }
        if (((_b = model.maxDailyAlarmEmailLimitPerSystem) !== null && _b !== void 0 ? _b : 0) > this.upperLimit) {
            Notifier.onWarning(`Limit cannot exceed ${this.upperLimit}`);
            return false;
        }
        if (((_c = model.maxDailyAlarmSmsLimitPerSystem) !== null && _c !== void 0 ? _c : 0) < this.lowerLimit) {
            Notifier.onWarning(`Limit cannot be lower than ${this.lowerLimit}`);
            return false;
        }
        if (((_d = model.maxDailyAlarmSmsLimitPerSystem) !== null && _d !== void 0 ? _d : 0) > this.upperLimit) {
            Notifier.onWarning(`Limit cannot exceed ${this.upperLimit}`);
            return false;
        }
        return true;
    }
    ;
    // helpers
    get isClientAdministrator() {
        return this.loginState.isClientAdministrator;
    }
    ;
    get isPowershieldUser() {
        return this.loginState.isPowerShield;
    }
    ;
    get maxDailyAlarmEmailLimitPerSystem() {
        var _a, _b;
        return (_b = (_a = this.data.notificationPreferences) === null || _a === void 0 ? void 0 : _a.maxDailyAlarmEmailLimitPerSystem) !== null && _b !== void 0 ? _b : 0;
    }
    ;
    set maxDailyAlarmEmailLimitPerSystem(value) {
        var _a;
        let model = (_a = this.data) === null || _a === void 0 ? void 0 : _a.notificationPreferences;
        if (!model)
            return;
        model.maxDailyAlarmEmailLimitPerSystem = value;
    }
    ;
    get maxDailyAlarmSmsLimitPerSystem() {
        var _a, _b;
        return (_b = (_a = this.data.notificationPreferences) === null || _a === void 0 ? void 0 : _a.maxDailyAlarmSmsLimitPerSystem) !== null && _b !== void 0 ? _b : 0;
    }
    ;
    set maxDailyAlarmSmsLimitPerSystem(value) {
        var _a;
        let model = (_a = this.data) === null || _a === void 0 ? void 0 : _a.notificationPreferences;
        if (!model)
            return;
        model.maxDailyAlarmSmsLimitPerSystem = value;
    }
    ;
    /// True only when somebody actually changed one of the limits. The caller uses this to decide
    /// whether to send them at all, so an untouched company keeps inheriting the default.
    get limitsWereEdited() {
        if (this.loadedEmailLimit === null && this.loadedSmsLimit === null)
            return false;
        return this.maxDailyAlarmEmailLimitPerSystem !== this.loadedEmailLimit
            || this.maxDailyAlarmSmsLimitPerSystem !== this.loadedSmsLimit;
    }
    get whenLastResetLimits() {
        var _a;
        if (!((_a = this.data.notificationSnapshot) === null || _a === void 0 ? void 0 : _a.whenLastResetLimits))
            return ``;
        return `(Last reset: ${DateHelper.convertToFriendlyMomentTimeString(this.data.notificationSnapshot.whenLastResetLimits)})`;
    }
    ;
};
__decorate([
    State("loginModule"),
    __metadata("design:type", typeof (_a = typeof LoginState !== "undefined" && LoginState) === "function" ? _a : Object)
], CompanyNotificationSummaryVue.prototype, "loginState", void 0);
__decorate([
    Prop(),
    __metadata("design:type", Number)
], CompanyNotificationSummaryVue.prototype, "companyId", void 0);
__decorate([
    Prop(),
    __metadata("design:type", Boolean)
], CompanyNotificationSummaryVue.prototype, "showSummary", void 0);
__decorate([
    Watch("companyId"),
    __metadata("design:type", Function),
    __metadata("design:paramtypes", []),
    __metadata("design:returntype", typeof (_b = typeof Promise !== "undefined" && Promise) === "function" ? _b : Object)
], CompanyNotificationSummaryVue.prototype, "getSummary", null);
CompanyNotificationSummaryVue = __decorate([
    Component({
        name: "CompanyNotificationSummaryVue",
        expose: ["validate", "maxDailyAlarmEmailLimitPerSystem", "maxDailyAlarmSmsLimitPerSystem", "limitsWereEdited"]
    })
], CompanyNotificationSummaryVue);
export default CompanyNotificationSummaryVue;
